import { useEffect } from 'react';
import { doTagSessionOverWrittenModalPage } from 'components/sessionTimeOut/tagging';

export const useRecordPage = ({ showModal, userProfile, productsDescription, setPageName }) => {
    useEffect(() => {
        if (showModal) {
            setPageName(doTagSessionOverWrittenModalPage(userProfile, productsDescription));
        }
    }, [showModal]);
};
